import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class NotificationApi extends BaseApi {
    constructor(client) {
        super(client, '/notification');
    }

    async getMyAll(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/my/all`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async markAsRead(id) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}/read`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async markAllAsRead() {
        try {
            const response = await this.client.post(`${this.basePath}/my/mark-all-read`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async registerPushToken(token) {
        try {
            const response = await this.client.post(`${this.basePath}/my/token`, { token });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
